import React from "react";
import { Badge } from "@mantine/core";

const STATUS_COLORS = {
  DFT: "gray",
  DRAFT: "gray",
  ACTIVE: "green",
  CLOSED: "red",
  NOT_STARTED: "gray",
  IN_PROGRESS: "blue",
  PASSED: "green",
  FAILED: "red",
};

const QuizStatusBadge = ({ status }) => (
  <Badge color={STATUS_COLORS[status] ?? "gray"} variant="filled">
    {status?.replace("_", " ") ?? "--"}
  </Badge>
);

export default QuizStatusBadge;
